import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { FUNDING_INSTRUMENTS } from '@fortem-monorepo/constants';
import { baseInstrumentSchema } from './shared/base.schema';
export const bankLegSchema = z.object({
    funding_instrument: z.enum(FUNDING_INSTRUMENTS),
    pay_amount: z.number(),
    receive_amount: z.number(),
    floater_spread: z.number(),
    swap_payments_yearly: z.number().int().positive(),
    first_floater_settlement_date: z.iso.date(),
    penultimate_floater_settlement_date: z.iso.date(),
    cash_settlement_payment_date: z.iso.date(),
});
export const aswapSchema = baseInstrumentSchema.extend({
    instrument_type: z.literal(INSTRUMENT_TYPE.Aswap),
    structure_name: z.string().min(1),
    fund_id: z.number().int().positive(),
    currency_id: z.number().int().positive(),
    counterparty_id: z.number().int().positive(),
    effective_date: z.iso.date(),
    maturity_date: z.iso.date(),
    bond_instrument_id: z.number().int().positive(),
    bond_currency_id: z.number().int().positive(),
    bank_legs: z.array(bankLegSchema).min(1).max(1),
});
